// Dispara `page_view` em cada mudança de rota.
// Plugado uma única vez dentro do <Router> em App.tsx.

import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAnalytics } from "@/hooks/useAnalytics";

const AnalyticsProvider = () => {
  const location = useLocation();
  const { track } = useAnalytics();

  useEffect(() => {
    // dispara após render
    track("page_view");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return null;
};

export default AnalyticsProvider;
